import React from 'react';
import styles from './index.module.less';
import cn from 'classnames';
import { CartItemType } from '@base/cart/interface';
import { observer } from 'base/store';

import { ICartGroup } from 'mod/cart/interface'
import { WholesalePriceRules } from '@app/common/WholesalePriceRules';
import { getUnitsRange, getWholesaleRangeIndex, hasWholeSalePrice } from '@pro/product/utils';

type CartItemPriceProps = {
    className?: string;
    item: CartItemType;
};

const CartItemPrice: React.FC<CartItemPriceProps> = props => {
    const {
        className,
        item,
    } = props;

    const {
        wholesalePrices,
        num,
        variantPriceExchangeDisplay
    } = item;

    return (
        <div className={cn(className, styles.prices, 'flex flex-middle')}>
            <span className={'g-price'}>{variantPriceExchangeDisplay}</span>
            {hasWholeSalePrice(item) && (
                <WholesalePriceRules
                    className={'ml-5 text-light'}
                    list={item.wholesalePrices}
                    activeIndex={getWholesaleRangeIndex(wholesalePrices, num)}
                />
            )}
        </div>
    );
};

export default CartItemPrice;